/**
 * @generated SignedSource<<0c071269289db131c404289dba64adda>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SchoolExamProblemDeleteInput = {
  id: string;
};
export type SchoolExamSourceId_schoolExamProblemDeleteMutation$variables = {
  input: SchoolExamProblemDeleteInput;
};
export type SchoolExamSourceId_schoolExamProblemDeleteMutation$data = {
  readonly schoolExamProblemDelete: {
    readonly id: string;
  };
};
export type SchoolExamSourceId_schoolExamProblemDeleteMutation = {
  response: SchoolExamSourceId_schoolExamProblemDeleteMutation$data;
  variables: SchoolExamSourceId_schoolExamProblemDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SchoolExamSourceId_schoolExamProblemDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SchoolExamProblem",
        "kind": "LinkedField",
        "name": "schoolExamProblemDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SchoolExamSourceId_schoolExamProblemDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SchoolExamProblem",
        "kind": "LinkedField",
        "name": "schoolExamProblemDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "abf634a26658d660f496174ca5fb2dea",
    "id": null,
    "metadata": {},
    "name": "SchoolExamSourceId_schoolExamProblemDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation SchoolExamSourceId_schoolExamProblemDeleteMutation(\n  $input: SchoolExamProblemDeleteInput!\n) {\n  schoolExamProblemDelete(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "56436ba56d20a881bf8e00c49b7ed1d6";

export default node;
